import { gql } from '@apollo/client';

export const SYNC_OBJECT_RELATIONSHIPS = gql`
    mutation syncObjectRelationships($input: SyncObjectRelationshipsInput!) {
        result: syncObjectRelationships(input: $input) {
                    success
                }
        }
`;
